/**
 * KeyPadConfigService: this service provides configuration data
 * and button data to properly display a list of buttons
 * for the re-usable key pad component.
 */

import { Injectable } from '@angular/core';
import { I18n } from '@app/i18n/strings-keys';
import { Initializable } from '@components/classes/initializable';

import {
  KeyPadConfig,
  KeyPadConfigSet,
  KeypadConfigType,
} from '@components/key-pad-module/interfaces';

@Injectable({ providedIn: 'root' })
export class KeyPadConfigService extends Initializable {
  private kpConfig: KeyPadConfigSet = {
    [KeypadConfigType.USER]: {
      nextButtonText: I18n.CommonButtons.Next,
      submitText: I18n.CommonActions.Apply,
      clearText: I18n.CommonActions.Cancel,
      resetText: I18n.CommonActions.Reset,
      kpType: KeypadConfigType.USER,
      format: 'number',
      minChar: 1,
      maxChar: 8,
      placeholder: I18n.CommonStrings.UserID,
    },
    [KeypadConfigType.PIN]: {
      submitText: I18n.CommonButtons.Enter,
      resetText: I18n.CommonActions.Reset,
      clearText: I18n.CommonButtons.Clear,
      kpType: KeypadConfigType.PIN,
      format: 'number',
      minChar: 1,
      maxChar: 16,
      placeholder: I18n.CommonStrings.PIN,
    },
    [KeypadConfigType.INTEGER]: {
      submitText: I18n.CommonStrings.Quantity,
      kpType: KeypadConfigType.INTEGER,
      format: 'number',
      minChar: 1,
      maxChar: 7,
      placeholder: '',
    },
    [KeypadConfigType.ITEM_COUNT]: {
      submitText: I18n.CommonStrings.Quantity,
      kpType: KeypadConfigType.INTEGER,
      format: 'number',
      minChar: 1,
      maxChar: 7,
      placeholder: '',
      defaultVal: '1',
    },
    [KeypadConfigType.ONLY_USER]: {
      submitText: I18n.CommonButtons.Enter,
      resetText: I18n.CommonActions.Reset,
      clearText: I18n.CommonActions.Cancel,
      kpType: KeypadConfigType.ONLY_USER,
      format: 'number',
      minChar: 1,
      maxChar: 8,
      placeholder: I18n.CommonStrings.UserID,
    },
    [KeypadConfigType.WEIGHT]: {
      submitText: '',
      kpType: KeypadConfigType.WEIGHT,
      format: 'number',
      minChar: 1,
      maxChar: 8,
      placeholder: '',
      precision: 2,
    },
  };

  public constructor() {
    super();
  }

  /**
   * Retrieves a configuration based on type
   *
   * @param {string} newType New type to set
   * @return {KeyPadConfig} The config object
   */
  public getConfig(newType: KeypadConfigType): KeyPadConfig {
    return this.kpConfig[newType];
  }

  public initialize() {}
}
